module.exports = __webpack_public_path__ + "static/media/ww_optimum1.a74aa3eb.gif";